export default "__VITE_ASSET__DkQtCtGd__"